module.exports = __webpack_public_path__ + "static/media/user.fbb8590a.svg";